import * as React from 'react'
import { SystemBreadCrumbBar } from './SystemBreadCrumbBar';


export class SystemDashboard extends React.Component {

    state = {
        items: ["Admin"]
    }

    constructor(props: any) {
        super(props);
        document.body.classList.add('sidebar-mini');
        document.body.classList.add('sidebar-collapse');
        document.body.classList.add('sidebar-expanded-on-hover');
        document.body.classList.add('sidebar-top-offset');
    }
    
    render() {
        return <>
            <SystemBreadCrumbBar />
        </>;
    }
}
